"use strict";
exports.empty = {
    closed: true,
    next: function (value) { },
    error: function (err) { throw err; },
    complete: function () { }
};
//# sourceMappingURL=Observer.js.map


// WEBPACK FOOTER //
// ./techpad-upgrade/~/rxjs/Observer.js